<div class="generic-navbar-spacer">
    <div class="background-color-alice-blue" style="border-top: 2px solid #F0F7FF">
        <div class="position-relative" style="min-height: 47rem;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>